module.exports = __webpack_public_path__ + "static/media/client-typedev.e0828a11.svg";